<template>
  <!-- @touchmove.stop 会造成滑动先触发touchmove事件 -->
  <!-- <div class="billboards" @touchmove.stop> -->
  <div class="billboards" :style="customStyle">
    <mt-swipe
      :auto="5000"
      :showIndicators="showIndicators"
      v-if="swipeAuto && billboardList.length > 0"
      class="border-radius-8"
    >
      <mt-swipe-item v-for="slider in billboardList" :key="slider.id">
        <!-- @click.native 支持原生事件绑定 -->
        <!-- <router-link :to="slider.href" @click.native="bannerClicked(slider.id)"> -->
        <!-- 或者在router-link包裹的元素绑定，原生组件用@click, vue组件用@click.native -->
        <!-- <router-link :to="slider.href">
              <lazy-img :src="slider.imgUrl" alt="slider"  width="100%" height="100%" @click.native="bannerClicked(slider.id)"></lazy-img>
            </router-link> -->
        <router-link
          :to="slider.href"
          v-if="slider.actionType !== ACTIONTYPE_DM"
        >
          <lazy-img
            :src="slider.imgUrl"
            alt="slider"
            width="100%"
            height="100%"
            @click.native="bannerClicked(slider.id)"
          ></lazy-img>
        </router-link>
        <a v-else href="#" @click="goToDaMai(slider)">
          <lazy-img
            :bannerHeight="bannerHeight"
            :src="slider.imgUrl"
            alt="slider"
          ></lazy-img>
        </a>
      </mt-swipe-item>
    </mt-swipe>
  </div> </template
>>

<script>
import { Swipe, SwipeItem } from "mint-ui";
import { isLogged, toLogin } from "@src/util/function";
import lazyImg from "./lazy-img";
import { FormatStringNew } from "@roots/pLibrary/javascriptTool.js";
const { noEmpty } = FormatStringNew;
import { signDaMaiNew } from "@src/service/daMai/daMai.js";
import { ACTIONTYPE_DM } from "@src/tools/consts/constsThird";
import {DMs} from "@src/pBusiness/index.js"
const {SET_DM_INFO} = DMs
export default {
  name: "billboards",
  props: {
    bannerHeight: {
      type: String,
      default: () => ""
    },
    billboardList: {
      type: Array,
      default: () => []
    },
    height: {
      type: [Number, String],
      default: 210
    },
    swipeAuto: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      ACTIONTYPE_DM,
      jumpDmParameter: {
        brandId: "",
        linkType: 1
      }
    };
  },
  computed: {
    showIndicators() {
      if (
        this.billboardList instanceof Array &&
        this.billboardList.length === 1
      ) {
        return false;
      }
      return true;
    },
    customStyle() {
      if (this.bannerHeight) {
        return {
          height: this.bannerHeight
        };
      } else if (this.height) {
        return {
          height: `calc((${this.height} / 375) * 100vw)`
        };
      }
      return {};
    }
  },

  methods: {
    goToDaMai(item) {
      const that = this;
      const _actionData =
        noEmpty(item.actionData) && JSON.parse(item.actionData);
      if (_actionData) {
        that.jumpDmParameter.brandId = Number(_actionData.businessId);
        that.jumpDmParameter.linkType = Number(_actionData.param);
      }
      that.jumpDmParameter.brandId &&
        (async function() {
          SET_DM_INFO(JSON.stringify(item.actionData))
          if (!isLogged()) {
            return toLogin();
          } else {
            const _res =  await signDaMaiNew(that.jumpDmParameter)
            _res && _res.data && _res.data.url (window.location.href = _res.data.url)
          }
        })();
    },
    bannerClicked(bannerId) {
      this.$emit("click-banner", bannerId);
    }
  },
  components: {
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    "lazy-img": lazyImg
  }
};
</script>
<style lang="less" scoped>
.billboards {
  margin-bottom: 10px;
  .mint-swipe {
    z-index: 12;
  }
}
</style>
